<script setup lang="ts">
import type { LocaleLinkItem } from '@fondof-ui/types'

const props = defineProps<{
  locale: LocaleLinkItem
  isLast?: boolean
}>()
</script>

<template>
  <span class="flex items-center">
    <a
      :href="props.locale.path"
      data-gtm-attr="button_footer"
      :data-gtm-label="props.locale.path"
      class="flex items-center justify-center text-sm uppercase transition-all duration-200"
    >
      {{ props.locale.code }}
    </a>

    <span
      v-if="!props.isLast"
      class="block pl-2 text-gray-400"
    >
      {{ ' /' }}
    </span>
  </span>
</template>
